import { render, staticRenderFns } from "./product-attribute-09.vue?vue&type=template&id=e1020c74"
import script from "./product-attribute-09.vue?vue&type=script&lang=js"
export * from "./product-attribute-09.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports